const irrigation_systems = [
    "grooves",
    "beams",
    "lying",
    "sprinkling",
    "located"
];

export default irrigation_systems;